/**
 * Sample payloads for Fusion Build guided-start paths — paste / load for manual QA.
 * Synthetic identifiers only (no real PII).
 */
export const SAMPLE_NCRP_JSON = `{
  "schema": "ncrp_complaint.v1",
  "complaint_id": "SYN-0147",
  "victim": {
    "name": "Ramesh Kumar",
    "phone": "+91 98765 43210",
    "state": "Maharashtra"
  },
  "incident": {
    "category": "investment_fraud",
    "amount_inr": 1800000,
    "narrative": "Victim transferred funds via UPI to a fake investment app beneficiary."
  },
  "transactions": [
    {
      "utr": "401234567890",
      "amount_inr": 600000,
      "ts": "2026-03-12T10:22:00+05:30",
      "beneficiary_vpa": "9876543210@ybl"
    },
    {
      "utr": "401234567891",
      "amount_inr": 700000,
      "ts": "2026-03-13T14:05:00+05:30",
      "beneficiary_vpa": "mule.layer1@okhdfcbank"
    },
    {
      "utr": "401234567892",
      "amount_inr": 500000,
      "ts": "2026-03-14T09:41:00+05:30",
      "beneficiary_account": {
        "acct": "50100123456789",
        "ifsc": "HDFC0001234",
        "bank": "HDFC"
      }
    }
  ]
}`;

export const SAMPLE_DEVICE_JSON = `{
  "schema": "device_extract.v1",
  "device": {
    "make": "Samsung",
    "model": "Galaxy A52",
    "imei": "356938035643809",
    "label": "Seized phone — A52"
  },
  "artefacts": [
    { "type": "wallet", "value": "TWd4WrZ9wn84f5x1hZhL4DHvk738ns5jwb", "note": "TronScan history open in Chrome" },
    { "type": "wallet", "value": "0x28C6c06298d514Db089934071355E5743bf21d60", "note": "Binance hot wallet bookmark" },
    { "type": "vpa", "value": "9876543210@ybl" },
    { "type": "phone", "value": "+919876543210" },
    { "type": "handle", "value": "@otc_desk_demo" }
  ]
}`;

export const SAMPLE_BANK_CSV = `date,direction,amount,description,utr,counterparty
2026-03-10,Cr,50000,NEFT IN from victim,401200000001,Ramesh Kumar
2026-03-11,Dr,48000,UPI to mule VPA,401200000002,9876543210@ybl
2026-03-12,Dr,1500,UPI self transfer,401200000003,holder@okhdfcbank
2026-03-13,Cr,200000,IMPS credit NCRP related,401200000004,Victim account
2026-03-14,Dr,195000,NEFT to exchange-linked acct,401200000005,HDFC ••6789
`;

/** Known demo wallet (WazirX TRX hot — public entity label in product demos). */
export const SAMPLE_WALLET = 'TWd4WrZ9wn84f5x1hZhL4DHvk738ns5jwb';

export type GuidedSampleId = 'ncrp' | 'frozen' | 'device' | 'wallet';

export const GUIDED_SAMPLE_HINTS: Record<GuidedSampleId, string> = {
  ncrp: 'Load sample NCRP JSON (SYN-0147), then Run → open Canvas.',
  frozen: 'Load sample bank CSV (or your statement PDF if StatementFlow is configured), then Run.',
  device: 'Load sample device_extract JSON (or upload a real .ufdr/.e01 on a bound case), then Run.',
  wallet: 'Load sample TRX wallet, Run, then use Suggested next step → Auto-Investigate / Trace.',
};
